import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import API, { setToken, getToken } from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = getToken();
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await API.get('/api/auth/me');
      setUser(data);
    } catch {
      setToken(null);
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await API.post('/api/auth/login', { email, password });
    setToken(data.token);
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await API.post('/api/auth/register', payload);
    setToken(data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await API.post('/api/auth/logout'); } catch {}
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
